module.exports = "/_next/static/images/dddd08b96986977026a9660c10b5931d-blog-xs-1x.jpg";